import React, { useState } from "react";
import { Link } from "react-router-dom"; // if you're using React Router

const Search = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const pages = [
    { name: "Home", path: "/home", internal: true },
    { name: "About Us", path: "/AboutUs", internal: true },
    { name: "Our School", path: "/OurSchool", internal: true },
    { name: "Our Heavenly Patron", path: "/OurHeavenlyPatron", internal: true },
    { name: "Principal’s Message", path: "/PrincipalMessage", internal: true },
    { name: "Manager’s Message", path: "/ManagersMessage", internal: true },
    {
      name: "Former Principal’s Message",
      path: "/FormerPrincipalMessage",
      internal: true,
    },
    { name: "CMC History", path: "/CMCHistory", internal: true },
    {
      name: "Management Committee ",
      path: "/ManagementCommittee",
      internal: true,
    },
    { name: "Facilities", path: "/Facilities", internal: true },
    { name: "Activities ", path: "/Activities", internal: true },
    { name: "Staff", path: "/Staff", internal: true },
    { name: "Mission", path: "/Mission", internal: true },
    { name: "Vision", path: "/Vision", internal: true },
    { name: " Our Motto", path: "/OurMotto", internal: true },
    { name: "Our Uniqueness", path: "/OurUniqueness", internal: true },
    { name: "Infrastructure", path: "/Infrastructure", internal: true },
    { name: "Student Strength", path: "/StudentStrength", internal: true },
    { name: "Admission Procedure", path: "/Admission", internal: true },
    { name: "Co-Curriculum", path: "/CoCurriculum", internal: true },
    {
      name: "Secondary Stage",
      path: "https://webapi.entab.info/api/image/CSSK/public/pdf/SecondarySyllabus.pdf",
      internal: false,
    },
    {
      name: "Middle Stage",
      path: "https://webapi.entab.info/api/image/CSSK/public/pdf/MiddleSyllabus.pdf",
      internal: false,
    },
    {
      name: "Preparatory Stage  ",
      path: "https://webapi.entab.info/api/image/CSSK/public/pdf/PreparatorySyllabus.pdf",
      internal: false,
    },
    {
      name: "Foundational Stage",
      path: "https://webapi.entab.info/api/image/CSSK/public/pdf/FoundationalSyllabus.pdf",
      internal: false,
    },
    { name: "Courses", path: "/Courses", internal: true },
    { name: "Circular", path: "/Circular", internal: true },
    { name: "To the Parents", path: "/ToTheParents", internal: true },
    { name: "School Timing", path: "/SchoolTiming", internal: true },
    {
      name: "School Transportation",
      path: "/SchoolTransportation",
      internal: true,
    },
    { name: "School Uniform", path: "/SchoolUniform", internal: true },
    { name: "Library Rules", path: "/LibraryRules", internal: true },
    { name: "Classroom Rules", path: "/Classroom", internal: true },
    { name: "School Fees", path: "/SchoolFees", internal: true },
    {
      name: "List of Books",
      path: "https://webapi.entab.info/api/image/CSSK/public/pdf/BookList.pdf",
      internal: false,
    },
    { name: "Gallery", path: "/Gallery", internal: true },
    { name: "Video Gallery", path: "/VideoGallery", internal: true },
    { name: "Life Tags ", path: "/LifeTags", internal: true },
    { name: "Covid Response", path: "/CovidResponse", internal: true },
    { name: "Events", path: "/Events", internal: true },
    { name: "Glimpse of the day", path: "/GlimpseOfTheDay", internal: true },
    { name: "CBSE", path: "/CbseDisclosure", internal: true },
    { name: "Alumni Association", path: "/AluminiAssociation", internal: true },
    { name: "Contact Us", path: "/ContactUs", internal: true },
  ];

  const filteredPages = pages.filter((page) =>
    page.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <>
      <form
        onSubmit={(e) => e.preventDefault()}
        className="d-flex align-items-center gap-4"
      >
        <i className="bi bi-search"></i>

        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </form>

      {searchTerm && (
        <ul className="searchlist">
          {filteredPages.map((page, index) => (
            <li key={index}>
              {page.internal ? (
                <Link to={page.path}>{page.name}</Link>
              ) : (
                <a href={page.path} target="_blank" rel="noopener noreferrer">
                  {page.name}
                </a>
              )}
            </li>
          ))}

          {filteredPages.length === 0 && <li>No pages found</li>}
        </ul>
      )}
    </>
  );
};

export default Search;
